if (!customElements.get("indent-enquiry")) {
  customElements.define(
    "indent-enquiry",

    class IndentEnquiry extends HTMLElement {
      constructor() {
        super();
        this.enquiryDetails = {
          email: "",
          name: "",
          phone: "",
        };

        this.currentVariant = undefined;
        this.productHandle = "";
        this.productHasVariants = false;
      }

      connectedCallback() {
        /* first, check wishlisted items */
        const _enquiryDetails = localStorage.getItem("xtra__enquiry-contact");
        try {
          const enquiryDetails = JSON.parse(_enquiryDetails);
          this.enquiryDetails = enquiryDetails;
          this.querySelector("input#name").value = enquiryDetails.name;
          this.querySelector("input#email").value = enquiryDetails.email;
          this.querySelector("input#phone").value = enquiryDetails.phone;
        } catch (err) {
          // error parsing JSON, just reset the store;
          this.enquiryDetails = {
            email: "",
            name: "",
            phone: "",
          };
          this.saveEnquiryDetailsToLocalStorage();
        }

        /* get product handle */
        const a = document.querySelector("[data-product-handle]");
        if (a === null) {
          // does not have any element with product handle, abort
          return;
        }
        this.productHandle = a.getAttribute("data-product-handle");

        /* listen to variant selection */
        const variantOptionsElem = document.querySelector("variant-options");

        if (variantOptionsElem) {
          const initialVariant = variantOptionsElem.currentVariant;
          this.currentVariant = initialVariant?.id;
          this.productHasVariants = true;

          // Update visibility based on initial variant availability
          this.updateFormVisibility(initialVariant?.available);

          variantOptionsElem.addEventListener(
            "variantChangeEnd",
            function (e) {
              const variant = e.target.currentVariant;
              this.currentVariant = variant?.id;
              this.updateFormVisibility(variant?.available);
            }.bind(this),
          );
        }

        const form = this.querySelector("form");
        form.addEventListener("submit", this.handleFormSubmit.bind(this));

        if (typeof window.turnstile !== "undefined") {
          this.renderTurnstile();
        } else {
          window.addEventListener("turnstile:ready", () => {
            this.renderTurnstile();
          });
        }
      }

      updateFormVisibility(variantAvailable) {
        // Find the product-form (add to cart) element
        const productForm = document.querySelector(
          "product-form.wt-product__add-to-cart",
        );
        const stickyBuyButton = document.querySelector("sticky-buy-button");

        if (variantAvailable) {
          // Variant is available: show add to cart, hide enquiry form
          if (productForm) productForm.style.display = "";
          if (stickyBuyButton) stickyBuyButton.style.display = "";
          this.style.display = "none";
        } else {
          // Variant is not available: hide add to cart, show enquiry form
          if (productForm) productForm.style.display = "none";
          if (stickyBuyButton) stickyBuyButton.style.display = "none";
          this.style.display = "";
        }
      }

      renderTurnstile() {
        const container = document.querySelector(".turnstile-container");
        if (container && !container.hasChildNodes()) {
          this.turnstileWidgetId = window.turnstile.render(container, {
            sitekey: "0x4AAAAAACJudVOBrpAnIKcS",

            callback: (token) => {
              this.turnstileToken = token;
            },
          });
        }
      }

      async handleFormSubmit(e) {
        e.preventDefault();

        const btn = e.target.querySelector("button[type=submit]");
        if (btn) {
          btn.setAttribute("disabled", "true");
          btn.innerText = "Submitting...";
        }

        try {
          const fd = new FormData(e.target);

          const name = fd.get("name");
          const email = fd.get("email");
          const phone = fd.get("phone");
          const contract_pricing = fd.get("contract_pricing") === "true";
          const productUrl = window.location.href;

          const r = await fetch(`/products/${this.productHandle}.json`);

          const productData = await r.json();

          const productTitle = `${productData.product.vendor}: ${productData.product.title}`;
          let productVariant = null;

          if (this.productHasVariants && this.currentVariant) {
            const matchingVariant = productData.product.variants.find(
              (a) => a.id === this.currentVariant,
            );
            productVariant = matchingVariant?.title ?? null;
          }

          const sendEnquiry = await fetch(
            //`http://localhost:3000/indent-enquiry`,
            `https://server-api.xtra.com.sg/indent-enquiry`,
            {
              method: "POST",
              body: JSON.stringify({
                name,
                email,
                phone,
                productTitle,
                productVariant,
                productUrl,
                cfTurnstileToken: this.turnstileToken,
                contract_pricing,
              }),
            },
          );

          const response = await sendEnquiry.json();

          this.enquiryDetails = {
            name,
            email,
            phone,
          };
          this.saveEnquiryDetailsToLocalStorage();

          if (response.ok) {
            vanillaToast.default("Enquiry submitted. ");

            if (btn) {
              btn.innerText = "Submitted";
            }
          }
        } catch (err) {
          console.error(err);
          vanillaToast.error("An unknown error has occurred. ");
        }
      }

      saveEnquiryDetailsToLocalStorage() {
        localStorage.setItem(
          "xtra__enquiry-contact",
          JSON.stringify(this.enquiryDetails),
        );
      }
    },
  );
}
